import {Box} from '@mui/material'
import {AuthProfileIcon} from '../../modules/auth/components/AuthProfileIcon'
import {NavigationTabs} from '../../modules/common/components/NavigationTabs'
import {useDashboardHelpers} from '../../modules/common/pages/useDashboardHelpers'
import {SelectInput, SelectInputItem} from '../inputs/SelectInput'
import {useCallback} from 'react'
import { useSelectedYear } from '../../modules/common/pages/SelectedYearContext'
import moment from 'moment'

export interface Props {
  className?: string
}

export const NavBar = ({className}: Props) => {
  const { selectedYear, setSelectedYear } = useSelectedYear()

  const {canViewQualificatorWidget, canViewExpertWidget} = useDashboardHelpers()
  
  const handleChange = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedYear(e.target.value)
  }, [setSelectedYear])

    const currentYear = moment().year()
    const startYear = 2023
    const items: SelectInputItem[] = [
      { label: 'All', value: '' },
      ...Array.from({ length: currentYear - startYear + 1 }, (_, i) => {
        const year = startYear + i
        return { label: year.toString(), value: year.toString() }
      })
    ]

  return (
    <Box
      className={className}
      sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}
    >
      <NavigationTabs />
      <Box sx={{display: 'flex', alignItems: 'center',}}>
      {(canViewQualificatorWidget() || canViewExpertWidget()) && (
          <SelectInput sx={{ marginRight: 2, height: 38.5 }} onChange={handleChange} value={selectedYear} label='Year' items={items} />
        )}
        <AuthProfileIcon />
      </Box>
    </Box>
  )
}
